<template>
    <v-app>
        <v-container fluid class="pb-0">
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Others
                                Info</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit" ref="projectBudgetDetailsForm"
                                    id="projectBudgetDetailsForm">
                                    <v-row class="pa-2">
                                        <v-col cols="12">
                                            <v-autocomplete variant="outlined" density="compact"
                                                bg-color="grey-lighten-4" v-model="selectedProject"
                                                :items="getProjectList"
                                                :item-title="(item) => `${item.project_title || item.name} - ${item.code || ''}`"
                                                item-value="id" autocomplete="off" clearable :loading="loading"
                                                @update:model-value="onProjectChange">
                                                <template #label>
                                                    Project
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete variant="outlined" density="compact"
                                                bg-color="grey-lighten-4" v-model="selectedBudget"
                                                :items="filteredBudgets"
                                                :item-title="(item) => `${item.id} - ${item.project?.project_title || item.project?.name || 'Unknown'} (${item.project?.code || 'N/A'})`"
                                                item-value="id" autocomplete="off" clearable :loading="loading"
                                                @update:model-value="onBudgetChange">
                                                <template #label>
                                                    Project Budget
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-textarea label="Description" density="compact" variant="outlined"
                                                bg-color="grey-lighten-4" v-model="description" autocomplete="off"
                                                rows="2" clearable></v-textarea>

                                            <v-date-input v-model="budgetCostDate" prepend-icon=""
                                                prepend-inner-icon="mdi-calendar" density="compact"
                                                variant="outlined" bg-color="grey-lighten-4" autocomplete="off"
                                                clearable :error-messages="budgetCostDate ? '' : ''">
                                                <template #label>
                                                    Budget Cost Date <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-date-input>





                                            <v-text-field label="Balance Amount" variant="outlined" density="compact"
                                                bg-color="grey-lighten-4"
                                                :model-value="formatCurrency(remainingBalance)"
                                                :class="getBalanceAmountClass(remainingBalance)"
                                                readonly></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">{{ isEditMode ?
                                'Edit' : 'Add' }}
                                Project Budget Details</v-expansion-panel-title>
                            <v-expansion-panel-text class="item-info-form" style="padding: 8px;">
                                <v-form @submit.prevent="submit" ref="projectBudgetDetailsForm"
                                    id="projectBudgetDetailsForm">
                                    <v-row dense class="ma-0" justify="center">
                                        <v-col cols="12" md="6" class="pa-1 mb-2">
                                            <v-autocomplete label="Select Cost Head" variant="outlined"
                                                density="compact" bg-color="grey-lighten-4" v-model="selectedCostHead"
                                                :items="getProjectThemeList" :item-title="(item) => item.name"
                                                item-value="id" :error-messages="selectedCostHead ? '' : ''"
                                                @update:model-value="addCostHeadItem" @keydown.enter="addCostHeadItem"
                                                autocomplete="off" clearable></v-autocomplete>
                                        </v-col>
                                    </v-row>

                                    <!-- Cost Head Items Table -->
                                    <v-row dense class="ma-0 mt-1">
                                        <v-col cols="12" class="pa-1">
                                            <v-table density="compact" :loading="loading" fixed-header
                                                class="table-dotted-border-bottom"
                                                style="height: 40vh; overflow-y: auto">
                                                <thead>
                                                    <tr>
                                                        <th class="text-center" style="width: 5%">SL</th>
                                                        <th class="text-left" style="width: 35%">
                                                            Cost Head
                                                        </th>
                                                        <th class="text-center" style="width: 20%">
                                                            Planned Amount
                                                        </th>
                                                        <th class="text-center" style="width: 20%">
                                                            Actual Amount
                                                        </th>

                                                        <th class="text-center" style="width: 5%">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in costHeadItems"
                                                        v-if="costHeadItems.length > 0" :key="index">
                                                        <td class="text-center py-1">{{ index + 1 }}</td>
                                                        <td class="text-left py-1" style="white-space: normal">
                                                            {{ item.cost_head_name }}
                                                        </td>
                                                        <td class="text-center py-1">
                                                            <v-text-field reverse="false" controlVariant="stacked"
                                                                label="" style="width: 120px" type="number" min="0"
                                                                step="0.01" density="compact" variant="outlined"
                                                                bg-color="grey-lighten-4" v-model="item.planned_amount"
                                                                hide-details
                                                                :error-messages="item.planned_amount < 0 ? 'Amount must be >= 0' : ''"></v-text-field>
                                                        </td>
                                                        <td class="text-center py-1">
                                                            <v-text-field reverse="false" controlVariant="stacked"
                                                                label="" style="width: 120px" type="number" min="0"
                                                                step="0.01" density="compact" variant="outlined"
                                                                bg-color="grey-lighten-4" v-model="item.actual_amount"
                                                                hide-details
                                                                :error-messages="item.actual_amount < 0 ? 'Amount must be >= 0' : ''"
                                                                @update:model-value="updateBalanceAmount(index)"></v-text-field>
                                                        </td>

                                                        <td class="text-center py-1">
                                                            <v-icon size="small" color="red" class="delete-button"
                                                                @click="removeCostHeadItem(index)">
                                                                mdi-delete
                                                            </v-icon>
                                                        </td>
                                                    </tr>

                                                    <tr v-else-if="loading == true">
                                                        <td colspan="6" class="text-center">
                                                            <v-skeleton-loader type="heading" :loading="loading" />
                                                        </td>
                                                    </tr>
                                                    <tr v-else>
                                                        <td colspan="6" class="text-center text-red">
                                                            You have no cost head items
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </v-col>
                                    </v-row>
                                    <!-- Close Cost Head Items Table -->

                                    <v-divider class="my-2"></v-divider>
                                    <v-card-actions class="pa-1">
                                        <v-row dense class="ma-0">
                                            <v-col cols="12" class="pa-1">
                                                <v-layout class="justify-end">
                                                    <v-btn class="bg-grey-darken-1 me-2" variant="flat"
                                                        @click="submitForm('draft')"
                                                        :loading="loading && currentButton === 'draft'">
                                                        DRAFT
                                                    </v-btn>
                                                    <v-btn class="bg-primary" variant="flat"
                                                        @click="submitForm('approved')"
                                                        :loading="loading && currentButton === 'approved'">
                                                        SAVE
                                                    </v-btn>
                                                </v-layout>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>


        </v-container>
    </v-app>

</template>

<script>
import Axios from 'axios';
import { toast } from "vue3-toastify";
import { ref, computed } from "vue";
import formattedDate from "@/plugins/dateFormatter";
import ProjectBudgetDetailsSetup from "@/components/module/project/budgetManagement/projectBudgetDetails.vue";

export default {
    components: {
        ProjectBudgetDetailsSetup,
    },
    data: () => ({
        panel: [0],
        panel2: [0],
        loading: false,
        dialog: false,
        data: {},

        // Form data for the new design
        selectedProject: null,
        selectedBudget: null,
        description: "",
        budgetCostDate: formattedDate(new Date()),
        selectedCostHead: null,
        costHeadItems: [],
        currentButton: "",

        // Edit mode properties
        isEditMode: false,
        editId: null,

        // Edit dialog properties
        editDialog: false,
        editData: {
            id: null,
            selectedProject: null,
            selectedBudget: null,
            budgetCostDate: formattedDate(new Date()),
            budgetAmount: null
        },
    }),
    watch: {},
    created() {
        // Load initial data
        if (this.$store.getters.getProjectList.length == 0) {
            this.$store.dispatch('getProjectList');
        }
        if (this.$store.getters.getProjectBudgetList.length == 0) {
            this.$store.dispatch('getProjectBudgetList');
        }
        if (this.$store.getters.getProjectThemeList.length == 0) {
            this.$store.dispatch('getProjectThemeList');
        }

        // Check for edit data in localStorage
        const editData = localStorage.getItem('budgetCostEditData');
        if (editData) {
            const item = JSON.parse(editData);
            this.populateEditData(item);
            localStorage.removeItem('budgetCostEditData'); // Clean up
        }
    },
    computed: {
        getProjectList() {
            return this.$store.getters.getProjectList || [];
        },
        getProjectBudgetList() {
            return this.$store.getters.getProjectBudgetList || [];
        },
        getProjectThemeList() {
            return this.$store.getters.getProjectThemeList || [];
        },
        filteredBudgets() {
            if (!this.selectedProject) return [];
            return this.getProjectBudgetList.filter(budget => budget.project_id == this.selectedProject);
        },
        selectedBudgetData() {
            if (!this.selectedBudget || !this.getProjectBudgetList.length) return null;
            return this.getProjectBudgetList.find(budget => budget.id == this.selectedBudget) || null;
        },
        totalBudgetAmount() {
            return this.selectedBudgetData ? parseFloat(this.selectedBudgetData.project_total_budget) || 0 : 0;
        },
        totalPlannedAmount() {
            return this.costHeadItems.reduce((sum, item) => sum + (parseFloat(item.planned_amount) || 0), 0);
        },
        remainingBalance() {
            return this.totalBudgetAmount - this.totalPlannedAmount;
        },
    },
    methods: {
        submit() {
            // Form submit method - handled by submitForm
        },

        onProjectChange(projectId) {
            this.selectedBudget = null;
            this.costHeadItems = [];
            if (projectId) {
                // Load project budgets if not already loaded
                if (this.getProjectBudgetList.length === 0) {
                    this.$store.dispatch('getProjectBudgetList');
                }
            }
        },
        onBudgetChange(budgetId) {
            this.costHeadItems = [];
            // Force reactivity update
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        addCostHeadItem(costHeadId) {
            if (!costHeadId && !this.selectedCostHead) {
                return; // No cost head selected
            }

            const costId = costHeadId || this.selectedCostHead;
            const costHeadData = this.getProjectThemeList.find(item => item.id == costId);
            if (!costHeadData) {
                toast.error('Invalid cost head selected');
                return;
            }

            // Check if cost head already exists
            const existingIndex = this.costHeadItems.findIndex(item => item.cost_id == costId);
            if (existingIndex >= 0) {
                toast.error('This cost head is already added');
                return;
            }

            const newItem = {
                cost_id: costId,
                cost_head_name: costHeadData.name,
                planned_amount: 0,
                actual_amount: 0,
                balance_amount: 0
            };

            this.costHeadItems.push(newItem);

            // Reset form field
            this.selectedCostHead = null;
        },
        removeCostHeadItem(index) {
            this.costHeadItems.splice(index, 1);
        },
        updateBalanceAmount(index) {
            const item = this.costHeadItems[index];
            if (item) {
                item.balance_amount = (parseFloat(item.planned_amount) || 0) - (parseFloat(item.actual_amount) || 0);
            }
        },
        populateEditData(item) {
            // Populate form with edit data
            this.selectedProject = item.project_id;
            this.selectedBudget = item.budget_id;
            this.description = item.remarks || '';
            this.budgetCostDate = item.budget_cost_date ? formattedDate(item.budget_cost_date) : formattedDate(new Date());

            // If there are budget cost details, populate them
            if (item.budgetCostDetails && item.budgetCostDetails.length > 0) {
                this.costHeadItems = item.budgetCostDetails.map(detail => ({
                    cost_id: detail.cost_id,
                    cost_head_name: detail.cost?.name || '',
                    planned_amount: detail.project_planned_amount || 0,
                    actual_amount: detail.project_actual_amount || 0,
                    balance_amount: (detail.project_planned_amount || 0) - (detail.project_actual_amount || 0)
                }));
            }

            // Set edit mode flag for form submission
            this.isEditMode = true;
            this.editId = item.id;
        },
        submitForm(status) {
            if (!this.selectedProject) {
                toast.error('Please select a project');
                return;
            }
            if (!this.selectedBudget) {
                toast.error('Please select a project budget');
                return;
            }
            if (this.costHeadItems.length === 0) {
                toast.error('Please add at least one cost head item');
                return;
            }

            this.currentButton = status;
            this.loading = true;

            const formData = {
                budget_cost_date: this.budgetCostDate,
                project_id: this.selectedProject,
                budget_id: this.selectedBudget,
                budget_amount: this.totalPlannedAmount,
                details: this.costHeadItems.map(item => ({
                    cost_id: item.cost_id || item.cost_head_id,
                    project_planned_amount: parseFloat(item.planned_amount) || 0,
                    project_actual_amount: parseFloat(item.actual_amount) || 0
                }))
            };

            // Add ID for edit mode
            if (this.isEditMode && this.editId) {
                formData.budget_cost_master_id = this.editId;
            }

            // Submit the form data
            this.$store.dispatch('saveUpdateProjectBudgetDetail', formData)
                .then((response) => {
                    toast.success(response.data.message || 'Budget details saved successfully');
                    this.resetForm();
                    this.$store.dispatch('getProjectBudgetDetailList');
                })
                .catch((error) => {
                    toast.error(error.response?.data?.message || 'Failed to save budget details');
                })
                .finally(() => {
                    this.loading = false;
                    this.currentButton = "";
                });
        },
        resetForm() {
            this.selectedProject = null;
            this.selectedBudget = null;
            this.description = "";
            this.budgetCostDate = formattedDate(new Date());
            this.datePickerMenu = false;
            this.costHeadItems = [];
            this.selectedCostHead = null;
            this.isEditMode = false;
            this.editId = null;
            this.closeEditDialog(); // Also reset edit dialog
        },
        openAddBudgetDetail() {
            this.data = {
                project_id: "",
                project_budget_id: "",
                cost_head_id: "",
                planned_amount: "",
                actual_amount: "",
                balance_amount: "",
                status: "1",
                budget_detail_id: null,
            };
            this.dialog = true;
        },
        saveBudgetDetailHandler(budgetDetail) {
            // Handle save callback if needed
        },
        formatCurrency(amount) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            }).format(amount || 0);
        },
        getBalanceAmountClass(balance) {
            const balanceNum = parseFloat(balance) || 0;
            if (balanceNum < 0) {
                return 'text-red-accent-4 font-weight-bold'; // Red for negative balance
            } else if (balanceNum > 0) {
                return 'text-green-accent-4 font-weight-bold'; // Green for positive balance
            }
            return 'text-grey-7'; // Grey for zero balance
        },

    },
    mounted() { }
}
</script>